import { render, staticRenderFns } from "./CaseUsers.vue?vue&type=template&id=31ae3080&scoped=true&"
import script from "./CaseUsers.vue?vue&type=script&lang=ts&"
export * from "./CaseUsers.vue?vue&type=script&lang=ts&"
import style0 from "./CaseUsers.vue?vue&type=style&index=0&id=31ae3080&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae3080",
  null
  
)

export default component.exports